/**
 * Class to build and render forms
 *
 * @author: Kete Martins
 * Date: 22/11/13
 * Time: 08:59
 */



Greenmile.PanelBuilder = Greenmile.PanelBuilder || {};

Greenmile.PanelBuilder.OrderByManager = (function () {

    function OrderByManager (form) {

        this.orders = {};
        this.values = null;

        this.setValues = function (values) {
            if (values) {
                this.values = values;
                for (var i = 0, length = values.length; i < length; i++) {
                    var orderBy = this.generateNewOrderBy();
                    orderBy.setValue(values[i]);
                }
            }
        };

        this.getOrderFiltersValue = function () {
            var i = 0;
            var panelOrderFilters = [];
            for (var key in this.orders) {
                i++;
                var orderValue = this.orders[key].getValue();
                var field = orderValue.field.getSelectedField();

                if(field) {
                    panelOrderFilters.push({
                        attribute: field.name,
                        entityField: {
                            id: field.id
                        },
                        orderType: orderValue.orderType.getValue(),
                        orderPriority: i
                    });
                }
            }

            return panelOrderFilters;
        }.bind(this);

        this.generateNewOrderBy = function () {
            var orderUuid = uuid.v1(),
                orderBy   = new Greenmile.PanelBuilder.OrderBy(this, orderUuid);

            this.orders[orderUuid] = orderBy;
            this.fieldsContainer.appendChild(orderBy.render());

            return orderBy;

        }.bind(this);

        this.getOrderBySection = function () {
            var container = document.createElement('div');
            this.fieldsContainer = document.createElement('div');

            container.className = 'orderBySection';
            this.fieldsContainer.className = 'fieldsContainer';

            container.appendChild(form.getTitleSection('Greenmile.PanelBuilder.OrderEditor'));
            container.appendChild(this.fieldsContainer);
            container.appendChild(Greenmile.PanelBuilder.Utils.getBtnNewItem('PanelBuilder.newAttribute', this.generateNewOrderBy));

            return container;
        }.bind(this);

    }

    return OrderByManager;

}());